/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */

enum SubmissionType {
    TestLeaf = "TestLeaf",
    TestFarmerSample = "TestFarmerSample",
    TestSoil = "TestSoil"
}

export default SubmissionType;
